// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary-button {
  padding: 16px 48px;
  background-color: var(--red);
  border: 1px solid var(--red);
  color: #FFFFFF;
  border-radius: 8px;
}

.primary-button-outline {
  background-color: #FFFFFF;
  color: var(--red);
}
`, "",{"version":3,"sources":["webpack://./src/components/button/PrimaryButton.scss","webpack://./src/components/button/PrimaryButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;ACCpB;;ADCE;EACE,yBAAyB;EACzB,iBAAiB;ACErB","sourcesContent":[".primary-button {\n  padding: 16px 48px;\n  background-color: var(--red);\n  border: 1px solid var(--red);\n  color: #FFFFFF;\n  border-radius: 8px;\n\n  &-outline {\n    background-color: #FFFFFF;\n    color: var(--red);\n  }\n}",".primary-button {\n  padding: 16px 48px;\n  background-color: var(--red);\n  border: 1px solid var(--red);\n  color: #FFFFFF;\n  border-radius: 8px;\n}\n\n.primary-button-outline {\n  background-color: #FFFFFF;\n  color: var(--red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
